import {
    DATA_TYPE,
    COMMUNICATION_FORMAT,
    DATA_FORMAT,
    DOMAIN_MAX_LENGTH,
} from "../../constants";

export const resourceSchema = {
    "resource": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "name": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "description": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "type": {
            type: DATA_TYPE.ENUM,
            enum: "ResourceType",
            value: null,
        },
        "size": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    }
} as const;
